import React from 'react';

const GubunColors = {
  개최전: '#676b69ff',
  개최중: '#6eb8f5ff',
  완료: '#61cf4aff',
  만료: '#fc4b4bff',
};

export default function Badge({ data }) {
  const bgColor = GubunColors[data?.state] || '#999';
  return (
    <div style={{ display: 'flex' }}>
      <div
        style={{
          display: 'inline-flex',
          whiteSpace: 'nowrap',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: bgColor,
          color: '#FFF',
          padding: '1px 8px',
          borderRadius: 4,
          marginRight: 8,
          fontSize: '12px',
          fontWeight: 'bold',
          maxHeight: '1.3rem',
        }}
      >
        {data?.state}
      </div>
      {data?.attendYn === 'Y' ? (
        <div
          style={{
            display: 'inline-flex',
            whiteSpace: 'nowrap',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #61cf4aff',
            color: '#61cf4aff',
            padding: '1px 8px',
            borderRadius: 4,
            marginRight: 8,
            fontSize: '12px',
            fontWeight: 'bold',
            maxHeight: '1.3rem',
          }}
        >
          참석
        </div>
      ) : (
        <div
          style={{
            display: 'inline-flex',
            whiteSpace: 'nowrap',
            alignItems: 'center',
            justifyContent: 'center',
            border: '1px solid #fc4b4bff',
            color: '#fc4b4bff',
            padding: '1px 8px',
            borderRadius: 4,
            marginRight: 8,
            fontSize: '12px',
            fontWeight: 'bold',
            maxHeight: '1.3rem',
          }}
        >
          불참
        </div>
      )}
    </div>
  );
}
